'use client'

import { useState } from 'react'

import newsletterPromotionSignupAction from '@/app/_lib/actions/NewsletterPromotionSignupAction'
import FormError from '@/app/_components/FormError'
import RecaptchaDisclaimer from '@/app/_components/RecaptchaDisclaimer'
import { useGlobalMessage } from '@/app/_lib/hooks'
import { useReCaptcha } from 'next-recaptcha-v3'
import { trackNewsletterSignup } from '@/app/_lib/analytics/ga4'

const initialFormState = {
    message: false,
    messages: [],
    errors: {
        email: false,
    },
}

export default function NewsletterSignupContent() {
    const addGlobalMessage = useGlobalMessage()
    const { executeRecaptcha } = useReCaptcha()

    const [serverResponse, setServerResponse] = useState(initialFormState)
    const [isPending, setIsPending] = useState(false)
    const [email, setEmail] = useState('')
    const [isSuccess, setIsSuccess] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsPending(true)

        const formData = new FormData(e.target)

        try {
            const token = await executeRecaptcha('newsletter_promotion_signup')

            if (!token) {
                addGlobalMessage({
                    message: 'Please try again in a moment.',
                    messageType: 'error'
                })
                setIsPending(false)
                return
            }

            formData.set('recaptchaToken', token)

            const response = await newsletterPromotionSignupAction(formData)
            setServerResponse(response)

            if (response.success) {
                trackNewsletterSignup()
                setIsSuccess(true)
                setEmail('')
                addGlobalMessage({
                    message: response.message,
                    messageType: 'success'
                })
            } else {
                addGlobalMessage({
                    message: response.message || 'Newsletter signup failed. Please try again.',
                    messageType: 'error'
                })
            }
        } catch (error) {
            addGlobalMessage({
                message: 'An error occurred. Please try again.',
                messageType: 'error'
            })
        } finally {
            setIsPending(false)
        }
    }

    if (isSuccess) {
        return (
            <div className="text-center py-8">
                <p className="text-lg text-green-600 mb-4">Thank you for signing up!</p>
                <p className="text-sm text-light">Check your email for your promotion code.</p>
            </div>
        )
    }

    return (
        <div>
            <form onSubmit={handleSubmit}>
                <div className="form-group mb-6">
                    <input
                        type="email"
                        id="newsletter_email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                        placeholder=" "
                        required
                        disabled={isPending}
                        className="form-input peer"
                    />
                    <label htmlFor="newsletter_email" className="form-input-label peer-placeholder-shown:form-input-label-placeholder-shown">Email</label>
                    <FormError addClasses="text-sm mt-1">{serverResponse?.errors?.email}</FormError>
                </div>
                <button
                    type="submit"
                    disabled={isPending}
                    className="btn btn-primary btn-sm w-full"
                >
                    {isPending ? 'Submitting...' : 'Sign Up'}
                </button>
            </form>
            <RecaptchaDisclaimer addClasses="text-xs mt-4" />
        </div>
    )
}
